export enum MainResource {
  App = 'Federación Nacional de cacaoteros',
  Home = 'Dashboard',
  ErrorBoundary = 'Something went wrong',
  TryAgain = 'Try again',
  SideBar = 'Módulos',
  Confirm = 'Confirmar',
  Cancel = 'Cancel',
  Rows = 'Usuarios',
  Politica1 = `De acuerdo con lo establecido en la Ley 1581 de 2012 y el Decreto Reglamentario 1377 de 2013,
  para el Tratamiento de datos personales y su régimen de protección, declaro de manera libre, expresa,
  inequívoca e informada, que AUTORIZO a LA FEDERACIÓN NACIONAL DE CACAOTEROS - FEDECACAO. para que,
  en los términos del literal a) del artículo 6 de la Ley 1581 de 2012, realice la recolección,
  almacenamiento, uso, circulación, supresión, suprima, comparta, actualice, transmita y en general
  realice el tratamiento de mis datos personales, incluyendo datos sensibles, como origen racial o étnico,
  mis huellas digitales, fotografías, videos y demás datos que puedan llegar a ser considerados como
  sensibles de conformidad con la Ley, para que dicho Tratamiento se realice con el fin de lograr las
  finalidades relativas a ser miembro o renovar la afiliación, participar en proyectos agrícolas, en
  actividades de capacitación, en programas de investigación, en programas de comercialización y mercadeo,
  en campañas de divulgación para lograr asimismo la verificación de información, antecedentes de todo
  orden, validación, registro, sin limitarse a ello de conformidad con los Estatutos que regulan a LA
  FEDERACIÓN NACIONAL DE CACAOTEROS - FEDECACAO, los requisitos convencionales y/o contractuales, y la Ley.`,

  Politica2 = `Declaro que se me ha informado de manera clara y comprensible que tengo derecho a conocer, actualizar y
  rectificar los datos personales proporcionados.`,
  Politica3 = `Declaro que conozco y acepto la Política de Tratamiento de Datos Personales de LA FEDERACIÓN NACIONAL 
  DE CACAOTEROS disponible en www.fedecacao.com.co, y que la información por mí proporcionada es veraz, 
  completa, exacta, actualizada y verificable. Mediante la firma del presente documento, manifiesto que 
  reconozco y acepto que cualquier consulta o reclamación relacionada con el Tratamiento de mis datos 
  personales podrá ser elevada verbalmente o por escrito ante LA FEDERACIÓN NACIONAL DE CACAOTEROS, 
  como Responsable del Tratamiento. Declaro y aceptó que LA FEDERACIÓN NACIONAL DE CACAOTEROS, en 
  cumplimento de lo establecido en la normativa de protección de datos personales que se cita, me ha 
  informado sobre mis derechos como titular de los Datos Personales. Autorizo a LA FEDERACIÓN NACIONAL 
  DE CACAOTEROS a modificar o actualizar su contenido, a fin de atender reformas legislativas, políticas 
  internas o nuevos requerimientos para la prestación u ofrecimiento de servicios o productos, dando aviso 
  previo por medio de la página web y/o correo electrónico.
`,
Politica4 = `En señal de aceptacion de lo anterior, consiento y autorizo que mis datos personales sean tratados conforme a lo previsto en la presente autorización.
`
}
